'use strict';

var React = require('react');
var _ = require('underscore');
var i18n = require('../helper/i18n');

var IOSWarning = React.createClass({
  propTypes: {
    logo: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    arrowClassName: React.PropTypes.string.isRequired
  },
  render: function () {
    var logo,
      name,
      arrowClassName;
    logo = this.props.logo;
    name = this.props.name;
    arrowClassName = 'arrow ' + this.props.arrowClassName;
    return (
      <div className="ios-warning">
        <div className="content">
          <div className="header">
            <div className="logo">
              <img src={logo} alt={name} width="64" height="64"/>
            </div>
            <h2>{name}</h2>
          </div>
          <div className="how-to-install">
            <h3>{i18n.get('INSTALL')}</h3>
            {this.props.children}
            <p className="open-now">{i18n.get('SKIP_INSTALL')} <br/><a href={window.location.href + '?force=1'}>{i18n.get('OPEN_NOW')}</a></p>
          </div>
        </div>
        <div className={arrowClassName}>
          <img className="top-right-arrow"
               src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAvNJREFUeJzt3MlOVEEcRvHjGOPDIKKIiCPO8zw+nC58CZY+hnFh4tp5QlCjLhrSmFtA3+66VQ3/80s6IRBuVfKdhAXJBUmSJEmSJEmSJEmSJEmSJEmSJGkL2Vv7AqpnAngDzNe+iMqbAN4Cf4FF4Gzd66ikA8A7euOvfhaBczUvpTJS4xtBEJOsP/7aCM7XuqC6Mwm8pz/0AvB65esl4Oman/3ACLaVgzTH3we8pB/ATpoRXKhxWeU1RXp8+D8ASEdwseRlldcU8IH0+NAMANIRXCpxWeV1iI3Hh3QA0IxgCSPYUgYZH9YPANIRXO7issrrMPCRzceHjQOAdARXcl5WeU0z+PiweQCQjuBqjssqr2ngE4OPD4MFAM0IljGCsXKE9uPD4AFAOoJrw1xWec0w3PjQLgBIR3C9zWWV1wzwmeHGh/YBQDqCGy1+X5kcZbTxYbgAwAiqm2X08WH4AKAZwU/g5hDPUUuzwBdGHx9GCwDSEdwa8lkawDHyjQ+jBwDpCG6P8DytY46840OeACAdwZ0Rn6k15oCv5B0f8gUAzQh+YQRZHKeb8SFvAJCO4G6mZ4d0gu7Gh/wBQDqCexmfH0bX40M3AUA6gvuZz9jWTgLf6HZ86C4ASEfwoINztp1S40O3AYARtHaKcuND9wGAEQys9PhQJgBoRvAbeNjxmVvKaeA7ZceHcgFAOoJHBc4de2eoMz6UDQDSETwudPZYmqfe+FA+AEhH8KTg+WPlOfXGhzoBQDOCFyvfC2cX8Iw640O9AKAfwQKwv8L5Y2MH9d7TUzMA6EWwp9LZDbsrnbv679OI/qx8xkLIv0HqM4DgDCA4AwjOAIIzgOAMIDgDCM4AgjOA4AwgOAMIzgCCM4DgDCA4AwjOAIIzgOAMIDgDCM4AgjOA4AwgOAMIzgCCM4DgDCA4AwjOAIIzgOAMIDgDCM4AgjOA4AwgOAMIrtZLomp6Re9Fjcu1LyJJkiRJkiRJkiRJkiRJkiRJkiRJktTWPyLpXQ2aP1sQAAAAAElFTkSuQmCC"
               width="64"
               height="64"
               alt="click here"/>
          <img
            className="bottom-center-arrow"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAtRJREFUeJzt3DdzU0EYRuGDWzKycQ5DY+j4sfwZGnKOJudQMhRUVFCY4toz9nJlK9zdlfydZ0YzbqRdzXsKN1cgSZIkSZIkSZIkSZIkSZIkSZKkqXSs9gUq2aT57n+BL5Xvogp+A9vA59oXqW2m9gVUlwEEZwDBGUBwBhCcAQRnAMEZQHAGEJwBBGcAwRlAcAYQnAEEZwDBGUBwBhCcAQRnAMEZQHAGEJwBBGcAwRlAcAYQnAEEZwDBGUBwBhCcAQRnAMEZQHAGEJwBBGcAwRlAcAYQXM0ANoHViufXdBFYrn2Jmi4DP2l+pq1GBDV/Ju4S8AP4ClyocH51M8AWzQC7I5SOoFYAu+Pvfverhc+fGBvAd+pFUCOAdPyXwFzB8yfOBvCNOhGUDsDx+1inTgQlA0jHfwHMFjh3aqzT/ENUMoJSAaTjb+H4rdYoG0GJANrG72U8b+qt0fx0e4kIcgeQjv8cxx/IKmUiyBlAOv4zHH8oqzTD5IwgVwBt45/r+IwQVsgbQY4A0vGf4vhjWQE+kSeCrgNw/EyWyRNBlwGk4z8BznbwudqxDHyk2wi6CiAd/zGOn0XXEXQRQNv4Z8b4PB1iie4iGDcAx69kCfjA+BGME0A6/iMcv6guIhg1gHT8hzh+FYvAe0aPYJQA2sY/PcT71bFF4B2jRTBsAOn4D3D8ibDAaBEME0A6/n0cf6IsAG8ZLoJBA2gb/9Q4l1Ue8wwXwSABpOPfw/En2jzwhsEiOCyAdPy7OP5UGDSCgwJoG/9kjssqj/PAaw6OoF8A6fh3cPypdB54Rf8I2gJIx7+N40+1OfpHkAbg+EfUHM1DGGkEewNIx78FnKhxWeXRFsGfnb9/sX/8mzj+kTRL80TO9gEvxz/iZtn/VPLe1w3geLWbqZge/0dwHccPpUfzpM42cA3HD6kHXMHxJUmSJEmSJEmSJEmSJEmSJEmSJEnSlPkHpRVX9BeF6C8AAAAASUVORK5CYII="
            width="64"
            height="64"
            alt="click here"/>
        </div>
      </div>
    );
  }
});

module.exports = IOSWarning;


// WEBPACK FOOTER //
// ./src/views/IOSWarning.jsx